if (!customElements.get('full-page-overlap-loader')) {
    /**
     * To show the loader:
     *   document.dispatchEvent(new Event('full-page-overlap-loader:enable'));
     *
     * To hide the loader:
     *   document.dispatchEvent(new Event('full-page-overlap-loader:disable'));
     */
    customElements.define(
        'full-page-overlap-loader',
        class FullPageOverlapLoader extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({ mode: 'open' });

                this._showHandler = this.show.bind(this);
                this._hideHandler = this.hide.bind(this);

                this._isVisible = false; // Track manually
            }

            connectedCallback() {
                this.render();
                // Hidden by default
                this.hide();
                // Listen for custom events - use capture to avoid accidental stopPropagation in other code
                document.addEventListener('full-page-overlap-loader:enable', this._showHandler, { capture: true });
                document.addEventListener('full-page-overlap-loader:disable', this._hideHandler, { capture: true });
            }

            disconnectedCallback() {
                document.removeEventListener('full-page-overlap-loader:enable', this._showHandler, { capture: true });
                document.removeEventListener('full-page-overlap-loader:disable', this._hideHandler, { capture: true });
            }

            show() {
                this.style.display = 'block';
                this._isVisible = true;
            }

            hide() {
                this.style.display = 'none';
                this._isVisible = false;
            }

            render() {
                this.shadowRoot.innerHTML = `
                    <style>
                        :host {
                            display: none;
                            position: fixed;
                            top: 0;
                            left: 0;
                            width: 100vw;
                            height: 100vh;
                            z-index: 99999;
                            background: rgba(255,255,255,0.9);
                            backdrop-filter: blur(3px);
                        }
                        .loader-center {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 100%;
                        }
                        .spinner {
                            width: 24px;
                            height: 24px;
                            border: 2px solid rgba(85, 102, 119, 0.2);
                            border-top: 2px solid #556677;
                            border-radius: 50%;
                            animation: spin 0.8s linear infinite;
                            margin: 0 auto;
                        }
                        @keyframes spin {
                            0% { transform: rotate(0deg);}
                            100% { transform: rotate(360deg);}
                        }
                    </style>
                    <div class="loader-center" aria-label="Loading, please wait">
                        <div class="spinner"></div>
                    </div>
                `;
            }
        }
    );
}
